module.exports = __webpack_public_path__ + "img/friendly-pool-2.cbd7af3b.jpg";